import React, { Component } from 'react'
import { connect } from 'react-redux'
import StyleSheet from 'styles'
import { DealSheetActions } from 'actionsets'
import Carousel, { CarouselItem } from 'components/Carousel'
import { FeaturedDealSheetCard } from 'components/deal_sheet/FeaturedDealSheetCard';
import Dependent from 'containers/shared/Dependent'

const FEATURED_LISTINGS_REFRESH_INTERVAL = process.env.REACT_APP_FEATURED_LISTINGS_AUTO_SCROLL_FREQUENCY

export class FeaturedListings extends Component {

  constructor(props) {
    super(props)
    DealSheetActions.bindActions(this)
  }

  dependenciesMet = () => {
    return this.props.requests.length === 0
  }

  dependsOn = () => {
    return this.actions.index({featured: true, visible: true})
  }

  render = () =>
    <Carousel
      autoScrollEvery={FEATURED_LISTINGS_REFRESH_INTERVAL}
      className={styles.featuredListingsCarousel}
      wrapperClassName={styles.featuredListingsContainer}
      showNavArrows={false}
      showNavDots={true}
      >
        {
          this.props.dealSheets.map(ds =>
            <CarouselItem key={ds.id}>
              <FeaturedDealSheetCard {...this.props.cardProps} dealSheet={ds} showMoreButton={true}/>
            </CarouselItem>
          )
        }
    </Carousel>

}

const styles = StyleSheet({
  featuredListingsContainer: {
    width: '100vw',
    margin: '0 auto'
  },
  featuredListingsCarousel: {
    display: 'flex',
    flexDirection: 'row',
    '& > div': {
      width: '100%',
      margin: '0',
      maxWidth: 'none'
    }
  }
})

export default connect(({dealSheets}) => dealSheets)(Dependent({loader: false, wrapperClassName: styles.wrapper})(FeaturedListings))